"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsVideoPQLBannerDismissed = exports.getFileManagerPortalDataFetchRequestStatus = exports.getFileManagerPortalDataUpdateRequestStatus = exports.getVidyardTosStatus = void 0;

var getVidyardTosStatus = function getVidyardTosStatus(state) {
  return state.fileManagerPortalData.get('vidyardTosStatus');
};

exports.getVidyardTosStatus = getVidyardTosStatus;

var getFileManagerPortalDataUpdateRequestStatus = function getFileManagerPortalDataUpdateRequestStatus(state) {
  return state.fileManagerPortalData.get('updateRequestStatus');
};

exports.getFileManagerPortalDataUpdateRequestStatus = getFileManagerPortalDataUpdateRequestStatus;

var getFileManagerPortalDataFetchRequestStatus = function getFileManagerPortalDataFetchRequestStatus(state) {
  return state.fileManagerPortalData.get('fetchRequestStatus');
};

exports.getFileManagerPortalDataFetchRequestStatus = getFileManagerPortalDataFetchRequestStatus;

var getIsVideoPQLBannerDismissed = function getIsVideoPQLBannerDismissed(state) {
  return state.fileManagerPortalData.get('isVideoPQLBannerDismissed');
};

exports.getIsVideoPQLBannerDismissed = getIsVideoPQLBannerDismissed;